<template>
  <div class="user-auth-box">
    <div class="msg-box">
      <img v-if="imgSrc" class="img" :src="imgSrc" />
      <p v-if="title" class="title" v-html="title"></p>
    </div>
    <div class="login-box">
      <p class="msg">{{ messageText }}</p>
      <div class="user-auth-input">
        <input :type="inputType" ref="input" v-model="inputVal" @change="inputChange" @blur="inputBlur"/>
      </div>
      <p class="vali-msg" v-if="valiMsg">{{valiMsg}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propData: {
      type: Object,
      default: {},
    },
  },
  data () {
    return {
      inputVal: "",
      inputType: "text",
      valiMsg: ""
    };
  },
  computed: {
    title () {
      return this.propData.title || "";
    },
    messageText () {
      return this.propData.messageText || "";
    },
    imgSrc () {
      return this.propData.imgSrc || "";
    },
  },
  mounted () {
    let that = this;
    that.propData.inputType && (that.inputType = that.propData.inputType);
    that.propData.inputVal && (that.inputVal = that.propData.inputVal);
    !that.propData.inputVal && that.$refs.input.focus();
    this.$emit("save", { USER_INPUT: this.inputVal });
  },
  methods: {
    async inputChange () {
      this.$emit("save", { USER_INPUT: this.inputVal });
      if (this.propData.inputValidate) {
        this.valiMsg = await this.propData.inputValidate(this.inputVal);
      }
    },
    inputBlur () {
      if (this.propData.inputValidate) {
        this.inputChange();
      }
    }
  },
};
</script>
<style lang="less" scoped>
.user-auth-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .msg-box {
    text-align: center;
    line-height: 1;
    .title {
      margin: 33px auto 18px;
      font-size: 50px;
      font-weight: bold;
      line-height: 66px;
      color: #232323;
    }
  }
  .login-box {
    p {
      margin: 0 auto 25px;
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
      color: #808992;
      text-align: center;
    }
  }
  .user-auth-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 130px 0 100px;
    font-size: 48px;
    font-weight: bold;
    line-height: 52px;
    color: #232323;
    &::before,
    &::after {
      content: "";
      display: block;
      width: 24px;
      height: 18px;
    }
    &::before {
      margin-right: 20px;
      background-image: url("~@img/home/05option/icon_zuo.png");
    }
    &::after {
      margin-left: 20px;
      background-image: url("~@img/home/05option/icon_you.png");
    }
  }
  .user-auth-input {
    input {
      display: block;
      margin: 0 auto;
      width: 366px;
      padding: 0 20px;
      height: 54px;
      font-size: 24px;
      background: linear-gradient(
        180deg,
        rgba(238, 242, 244, 1),
        rgba(245, 246, 248, 1)
      );
      border: 2px solid rgba(161, 166, 185, 1);
      box-shadow: inset 0px 3px 2px 0px rgba(34, 49, 89, 0.2);
      border-radius: 4px;
      &:focus {
        outline: none;
      }
      &::placeholder,
      &:-ms-input-placeholder {
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/userInput.vue